/**
 *
 *  TruBe Tooltip
 *  Kit Component
 *
 *  Created by Vladimir Shislyannikov on 01/10/2022.
 *  Copyright (c) 2022 iWoo Ltd. All rights reserved.
 *
 */

import React from 'react';
// import createReactClass from 'create-react-class';
import PropTypes from 'prop-types'; // use directly
// import ReactDOM from 'react-dom';
import { findDOMNode } from 'react-dom';
import clsx from 'clsx';

import { withStyles, Theme } from '@material-ui/core/styles';

import { makeCancelable } from '../../utils';

const styles = ((theme: Theme) => ({
  tbkTooltip: {
    display: 'block',
    position: 'absolute',
    'word-wrap': 'break-word',
    color: theme.redLight, // '#FFFFFF',
    'z-index': 99,

    "&.top $tbkTooltipArrow": {
      left: '0',
      bottom: '0',
      'margin-bottom': '-4px',

      /* Remove later */
      "&.flipX": {
        transform: 'scaleX(-1)',
      }
    },

    "&.bottom $tbkTooltipArrow": {
      top: '-4px',
      bottom: 'auto',
      transform: 'scale(-1)'
    },

    "&.right $tbkTooltipArrow": {
      left: '-4px',
      bottom: '-4px',

      "&.flipX": {
        transform: 'scaleX(-1)',
      }
    },

    "&.left $tbkTooltipArrow": {
      right: '-4px',
      bottom: '0'
    },

    "&.top": {
      "&.right $tbkTooltipArrow": {
        left: '0', // 'auto',
        right: '0',
        bottom: '0',

        "&.flipX": {
          transform: 'scaleX(-1)'
        }
      }
    },

    "&.top.right $tbkTooltipArrow": {
      "&.flipX": {
        transform: 'scaleX(-1)'
      }
    },

    "&.top.left $tbkTooltipArrow": {
      left: '0',
      bottom: '0',

      "&.flipX": {
        transform: 'scaleX(-1)'
      },

      "&.flipY": {
        transform: 'scaleY(-1)'
      }
    },

    "&.is-show.enter": {
      'webkit-transform': 'translate(0)',
      'ms-transform': 'translate(0)',
      'o-transform': 'translate(0)',
      transform: 'translate(0)',
      opacity: 0
    },

    "&.is-show.enter.enter-active": {
      transition: 'transform .3s ease-in,opacity .3s ease-in'
    },

    "&.is-show, &.is-show.enter.enter-active, &.leave": {
      'webkit-transform': 'translateY(-8px)',
      'ms-transform': 'translateY(-8px)',
      'o-transform': 'translateY(-8px)',
      transform: 'translateY(-8px)',
      opacity: 1
    },

    "&.is-show.leave.leave-active": {
      'webkit-transform': 'translate(0)',
      'ms-transform': 'translate(0)',
      'o-transform': 'translate(0)',
      transform: 'translate(0)',
      opacity: 0,
      transition: 'transform .3s ease-in,opacity .3s ease-in'
    }
  },

  tbkTooltipArrow: {
    position: 'absolute',
    width: '20px',
    height: '20px',
    'background-image': `url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3E%3Cpath fill='%23F1644A' d='M.001 0L0 8.808C5.023 14.702 12.047 18.795 20.001 20l-.325-.385A33.48 33.48 0 0111.994 0H.001z'/%3E%3C/svg%3E")`,
    'background-size': '20px',
    'z-index': -1
  },

  tbkTooltipArrowBlack: {
    'background-image': `url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3E%3Cpath fill='%23303740' d='M.001 0L0 8.808C5.023 14.702 12.047 18.795 20.001 20l-.325-.385A33.48 33.48 0 0111.994 0H.001z'/%3E%3C/svg%3E")`,
  },

  flipX: {

  },
  tbkTooltipInner: {
    padding: '8px 16px',
    'background-color': theme.redLight, //theme.greyMain, // '#303740',
    'border-radius': '16px'
  },

  tbkTooltipBottom: {
    width: '256px',
    right: '0',
    left: 'auto',
    transform: 'translateX(0)',

    "$tbkTooltipArrow": {
      left: 'auto',
      right: '0',
      bottom: '0',
      'margin-right': '12px',
      'margin-bottom': '-4px',
      transform: 'translateX(0)'
    }
  },

  tbkTooltipBottomRight: {
    width: '256px',
    right: '3px',
    left: 'auto',
    transform: 'translateX(0)',

    "$tbkTooltipArrow": {
      left: 'auto',
      right: '0',
      bottom: '0',
      'margin-right': '12px',
      transform: 'translateX(0)'
    }
  },

  tbkTooltipGray: {
    filter: 'drop-shadow(rgba(0,0,0,.2) 0 2px 5px)',
    'webkit-filter':  'drop-shadow(rgba(0,0,0,.2) 0 2px 5px)',

    "$tbkTooltipArrow": {
      width: '12px',
      height: '12px',
      'margin-left': '-3px',
      'margin-bottom': '-5px',
      'background-color': '#EEEEEE'
    },

    "$tbkTooltipInner": {
      padding: '13px 20px',
      'font-size': '16px',
      'font-family': "Poppins",
      'background-color': '#EEEEEE',
      'text-align': 'left'
    },

    "$tooltipDesc": {
      'line-height': 1.5
    },
  },

  "tbkTooltipStarTooltip": {
    top: '-50px',
    left: '50%',
    'margin-left': '-50px',
    filter: 'drop-shadow(rgba(0,0,0,.15) 0 1px 4px)',
    'webkit-filter':  'drop-shadow(rgba(0,0,0,.15) 0 1px 4px)',

    "$tbkTooltipArrow": {
      left: '50%',
      bottom: '0',
      'margin-left': '-4px',
      'margin-bottom': '-3px'
    },

    "$tbkTooltipInner": {
      width: '100px',
      border: '1px solid #dedfe0',
      'border-radius': '3px',
      'moz-border-radius': '3px',
      'webkit-border-radius': '3px',
      padding: '9px 10px',
      'text-align': 'center',

      "$tooltipTitle": {
        'text-transform': 'uppercase',

        "$tooltipDesc": {
          color: 'rgb(0, 0, 0)'
        }
      }
    }
  },

  thumbnailContainer: {
    display: 'flex',
    'flex-wrap': 'wrap',
    padding: '5px',
    'overflow-y': 'auto',
  },
  apNavView: {
    // table {
    'border-collapse': 'collapse',
    // }
  },
  apCalendarGrid: {
    height: 'auto',
    'border-collapse': 'collapse',
  },
  apCalendarRow: {
  // tr {
    'border-bottom': '1pt solid rgb(203, 207, 213)',
  // }
  },
  apHeadCell: {
    'font-family': "'Poppins', Arial, sans-serif",
    'font-weight': 400,
    'font-size': '12px',
    'text-align': 'center',
    'text-transform': 'uppercase',
    color: theme.grey, // #6B7178
    // .ap-cell, .ap-head-cell {
    // text-align: center;
    padding: '0',
    border: '0',
    'padding-bottom': '10px',
    // }
  },
  apCell: {
    width: '40px',
    height: '40px',
    color: '#333',
    padding: '3px', // '9px 8px',
    'border-radius': '8px',
    cursor: 'pointer',
    'line-height': 'normal',
    border: '1px solid transparent',
    'text-align': 'center',
  },
  apBtn: {
    position: 'relative',
    // margin: '0 auto',
    // 'border-radius': '4px',
    'border-radius': '50%',
    // 'line-height': '24px',
    width: '44px',
    height: '44px',
    // margin: '4px auto',
    // padding: '10px 8px',
    padding: '8px',
    'font-size': '14px',
    'font-weight': '400',
    'line-height': '26px',
    'letter-spacing': 'normal',
    'font-family': '"Poppins",sans-serif',
    border: '1px solid transparent',
    "&:hover": {
      'background-color': theme.greyLight, // #F8F8F8
      border: '1px solid rgb(203, 207, 213)',
    },
  },
  // apBtn: {

  // },
  apStateDisabled: {
    color: '#999',
    filter: 'alpha(opacity=7)',
    opacity: '.7',
  },
  apStateSelected: {
    background: theme.greyLight, // #F8F8F8
    border: '1px solid rgb(203, 207, 213)',
  },
  apCellOffRange: {
    color: '#999',
    "& :hover": {
      'background-color': 'transparent',
      'border-color':  'transparent',
    }
  },
  // apBtn: {

// .rw-btn, .rw-filter-input, .rw-input, .rw-input-reset {
//     color: inherit;
//     padding: '0';
//     margin: 0;
//     border: none;
//     box-shadow: none;
//     background: none;
//     background-image: none;
//     font-family: inherit;
//     font-size: inherit;
//     line-height: inherit;
//     -ms-touch-action: manipulation;
//     touch-action: manipulation;
// }
  // },
  apNow: {
    color: theme.red,
  }
}));

const ARROW_OFFSET = 4;
const ARROW_WIDTH = 20;
// const ARROW_HEIGHT = 20;
// const AUTOHIDE_TIME = 4000;
const MAX_WIDTH = 256;


class Tooltip extends React.Component {

  static propTypes = {
    disabled: PropTypes.bool,
    tooltipInnerStyle: PropTypes.object,
    element: PropTypes.object,
    isShow: PropTypes.bool,
    color: PropTypes.string,
    adjust: PropTypes.bool,
    autoHide: PropTypes.bool,
    delay: PropTypes.number,
    inside: PropTypes.bool,
    placement: PropTypes.oneOfType([PropTypes.string, PropTypes.func,]).isRequired,
    duration: PropTypes.number,
    onAfterHide: PropTypes.func,
    onClick: PropTypes.func,
  }

  static defaultProps = {
    autoHide: true,
    adjust: false,
    duration: 300,
  }

  constructor(props) {
    super(props);

    this.state = {
      tooltipPosition: {
        left: null,
        top: null,
        right: null,
        bottom: null,
      },
      arrowOffset: {
        left: null,
        right: null,
      }
    };
  }

  getPosition (inside) {
    var top,
      left,
      width,
      height;

    if (this.props.element && this.props.element.current) {
      let elem = findDOMNode(this.props.element.current);
      let rect = elem.getBoundingClientRect();

      top = rect.top + window.pageYOffset - window.document.documentElement.clientTop;
      left = rect.left + window.pageXOffset - window.document.documentElement.clientLeft;
      width = rect.width;
      height = rect.height;
    }

    return Object.assign({}, (inside ? { top: 0, left: '0' } : { top, left }), {
      width,
      height,
    });
  }

  show () {
    const { adjust, duration, inside, } = this.props;
    var pos,
      actualWidth,
      actualHeight,
      placement,
      tooltipPosition,
      arrowOffset;

    if (this.props.children && !this.props.disabled) {
      if (this.hideWithAnimationCancelablePromise) {
        this.hideWithAnimationCancelablePromise.cancel();
        this.hideWithAnimationCancelablePromise = null;

        var leaveStatus = {
          leaveAnimation: false,
          leaveActiveAnimation: false,
        };
      }

      this.setState(Object.assign({ isShow: true, enterAnimation: true }, leaveStatus));

      placement = typeof this.props.placement == 'function' ?
        this.props.placement.call(this, this.props.element.current) :
        this.props.placement;


      pos = this.getPosition(inside);

      if (this.tooltipRef) {
        actualWidth = this.tooltipRef.offsetWidth > 256 || this.props.children.length > 50 ? MAX_WIDTH : this.tooltipRef.offsetWidth;

        // Wait for the height to recalculate
        this.setState({ width: actualWidth + 1/* Android fix */ }, () => {
          actualHeight = this.tooltipRef.offsetHeight;

          switch (placement) {
            case 'bottom':
              tooltipPosition = { top: pos.top + pos.height, left: pos.left + pos.width / 2 - actualWidth / 2 };
              arrowOffset = { left: adjust ? actualWidth / 2 - ARROW_WIDTH / 2 : 0, right: '0' };
              break;
            case 'top':
              tooltipPosition = { top: pos.top - actualHeight - ARROW_OFFSET, left: pos.left + pos.width / 2 - actualWidth / 2 };
              arrowOffset = { left: adjust ? actualWidth / 2 - ARROW_WIDTH / 2 : 0, right: '0', flipX: true/* Hack */ };
              break;
            case 'left':
              tooltipPosition = { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left - actualWidth };
              arrowOffset = { left: adjust ? Math.max(pos.width / 2, actualWidth - ARROW_WIDTH) : 0, right: '0' };
              break;
            case 'right':
              tooltipPosition = { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left + pos.width };
              arrowOffset = { left: adjust ? Math.max(pos.width / 2, actualWidth - ARROW_WIDTH) : 0, right: '0' };
              break;
            case 'top left':
              tooltipPosition = { top: pos.top - actualHeight - ARROW_OFFSET, left: '0' };
              arrowOffset = { left: adjust ? Math.min(pos.width / 2 - ARROW_WIDTH - 8, actualWidth - ARROW_WIDTH - 8) : 0, right: '0', flipX: Math.min(pos.width / 2, actualWidth / 2 - ARROW_WIDTH - 8) < actualWidth / 2 };
              break;
            case 'top right':
              tooltipPosition = { top: pos.top - actualHeight - ARROW_OFFSET, left: pos.left + pos.width - actualWidth };
              arrowOffset = { left: adjust ? Math.min(pos.width / 2 - ARROW_WIDTH - 8, actualWidth- ARROW_WIDTH - 8) : 0, flipX: true/* Hack */ || Math.min(pos.width / 2, actualWidth / 2 - ARROW_WIDTH - 8) > actualWidth / 2 }; // TODO: fix this
              // arrowOffset = { right: adjust ? Math.min(pos.width / 2, actualWidth) : 0, flipX: Math.min(pos.width / 2, actualWidth / 2 - ARROW_WIDTH - 8) > actualWidth / 2 };
              break;
            default: // 'top'
              tooltipPosition = { top: pos.top - actualHeight - ARROW_OFFSET, left: pos.left + pos.width / 2 - actualWidth / 2 };
              arrowOffset = { left: adjust ? actualWidth / 2 - ARROW_WIDTH / 2 : 0, right: '0', flipX: true/* Hack */ };
          }

          var enterAnimationPromise = new Promise((resolve, reject) => {
            this.setState({ tooltipPosition, arrowOffset, enterActiveAnimation: true });

            setTimeout(() => {
              resolve();
            }, duration);
          });

          this.enterAnimationCancelablePromise = makeCancelable(enterAnimationPromise);

          this.enterAnimationCancelablePromise.promise
            .then(() => {
              this.setState({ enterAnimation: false, enterActiveAnimation: false });
            });
        });
      }
    }
  }

  hide () {
    const { duration, } = this.props;

    if (this.enterAnimationCancelablePromise) {
      this.enterAnimationCancelablePromise.cancel();
      this.enterAnimationCancelablePromise = null;

      var enterStatus = {
        enterAnimation: false,
        enterActviveAnimation: false,
      };

    }

    var hideWithAnimationPromise = new Promise((resolve, reject) => {
      this.setState(Object.assign({ enterAnimation: false, enterActiveAnimation: false, leaveAnimation: true, leaveActiveAnimation: true }, enterStatus));

      setTimeout(() => {
        resolve();
      }, duration);
    });

    this.hideWithAnimationCancelablePromise = makeCancelable(hideWithAnimationPromise);

    this.hideWithAnimationCancelablePromise.promise
      .then(() => {
        this.setState({
          leaveAnimation: false,
          leaveActiveAnimation: false,
          isShow: false,
          width: '',
        }, this.afterHide);
      });
  }

  afterHide () {
    this.hideWithAnimationCancelablePromise = null;

    this.props.onAfterHide && this.props.onAfterHide();
  }

  componentDidMount() {
    if (this.props.isShow) {
      this.show();
    }
  }

  componentDidUpdate (prevProps, prevState) {

    if (this.props.isShow && !prevProps.isShow) {
      this.show();
    } else if (!this.props.isShow && prevProps.isShow && !this.hideWithAnimationCancelablePromise) {
      this.hide();
    }
  }

  componentWillUnmount () {
    this.tooltipRef = null;
    if (this.enterAnimationCancelablePromise) {
      this.enterAnimationCancelablePromise.cancel();
      this.enterAnimationCancelablePromise = null;
    }
    if (this.leaveAnimationCancelablePromise) {
      this.leaveAnimationCancelablePromise.cancel();
      this.leaveAnimationCancelablePromise = null;
    }
  }

  render () {
    return (
      <div
        ref={ elem => this.tooltipRef = elem }
        className={clsx(this.props.classes.tbkTooltip, this.props.placement, this.props.className, { 'is-show': this.state.isShow, enter: this.state.enterAnimation, 'enter-active': this.state.enterActiveAnimation, leave: this.state.leaveAnimation, 'leave-active': this.state.leaveActiveAnimation, })}
        role='tooltip'
        style={{ ...this.props.style, visibility: this.state.isShow ? 'visible' : 'hidden', width: this.state.width, /*opacity: this.state.isShow ? 1 : 0, */top: this.state.tooltipPosition.top, left: this.state.tooltipPosition.left }}
        onClick={this.props.onClick}
      >
        <div className={clsx(this.props.classes.tbkTooltipArrow, { 'flipX': this.state.arrowOffset.flipX, [this.props.classes.tbkTooltipArrowBlack]: this.props.color === '#303740' })} style={{ 'marginLeft': this.state.arrowOffset.left, 'marginRight': this.state.arrowOffset.right }}></div>
        <div className={this.props.classes.tbkTooltipInner} style={{ ...this.props.tooltipInnerStyle }}>
          {this.props.children}
        </div>
      </div>
    );

  }
}

export default withStyles(styles)(Tooltip);
